import React from 'react';
import './LegalPages.css';

const TermsOfService = () => {
  return (
    <div className="legal-page">
      <div className="container">
        <h1>Terms of Service</h1>
        <p className="last-updated">Last updated: January 1, 2025</p>
        
        <section>
          <h2>1. Acceptance of Terms</h2>
          <p>By accessing and using the services of Prangio Designs Pte. Ltd. ("Company", "we", "us"), you accept and agree to be bound by the terms and provision of this agreement.</p>
        </section>

        <section>
          <h2>2. Services</h2>
          <p>Prangio Designs provides architectural design, interior design, renovation, and consultation services. All services are subject to availability and our professional capacity.</p>
          
          <h3>Service Scope</h3>
          <ul>
            <li>Architectural design and planning</li>
            <li>Interior design and space planning</li>
            <li>Renovation and remodeling consultation</li>
            <li>Project management services</li>
          </ul>
        </section>

        <section>
          <h2>3. Client Responsibilities</h2>
          <p>Clients agree to:</p>
          <ul>
            <li>Provide accurate and complete project information</li>
            <li>Make timely payments as per agreed terms</li>
            <li>Obtain necessary permits and approvals</li>
            <li>Provide site access as required</li>
            <li>Communicate changes or concerns promptly</li>
          </ul>
        </section>

        <section>
          <h2>4. Payment Terms</h2>
          <p>Payment terms will be specified in individual project contracts. Generally:</p>
          <ul>
            <li>Consultation fees are payable in advance</li>
            <li>Project fees may be structured in phases</li>
            <li>Late payment may incur additional charges</li>
            <li>All payments are subject to applicable taxes under Indian law</li>
          </ul>
        </section>

        <section>
          <h2>5. Intellectual Property</h2>
          <p>All designs, drawings, and creative work remain the intellectual property of Prangio Designs until full payment is received. Upon full payment, clients receive usage rights for the intended project only.</p>
        </section>

        <section>
          <h2>6. Limitation of Liability</h2>
          <p>Our liability is limited to the fees paid for our services. We are not liable for:</p>
          <ul>
            <li>Construction defects or contractor errors</li>
            <li>Delays due to permit or approval processes</li>
            <li>Changes in building codes or regulations</li>
            <li>Third-party actions or omissions</li>
          </ul>
        </section>

        <section>
          <h2>7. Cancellation and Refunds</h2>
          <p>Cancellation terms will be specified in individual contracts. Generally:</p>
          <ul>
            <li>Work completed up to cancellation date will be charged</li>
            <li>Refunds are subject to work completion status</li>
            <li>Minimum charges may apply for project initiation</li>
          </ul>
        </section>

        <section>
          <h2>8. Governing Law</h2>
          <p>These terms are governed by the laws of India. Any disputes will be subject to the jurisdiction of courts in Chennai, Tamil Nadu.</p>
        </section>

        <section>
          <h2>9. Privacy and Data Protection</h2>
          <p>We are committed to protecting your privacy in accordance with the Information Technology Act, 2000 and applicable Indian privacy laws. Please refer to our Privacy Policy for details.</p>
        </section>

        <section>
          <h2>10. Force Majeure</h2>
          <p>We are not liable for delays or failures due to circumstances beyond our control, including natural disasters, government actions, or other force majeure events.</p>
        </section>

        <section>
          <h2>11. Modifications</h2>
          <p>We reserve the right to modify these terms at any time. Changes will be effective upon posting on our website. Continued use of our services constitutes acceptance of modified terms.</p>
        </section>

        <section>
          <h2>12. Contact Information</h2>
          <p>For questions regarding these terms, please contact us:</p>
          <div className="contact-details">
            <p><strong>Prangio Designs Pte. Ltd.</strong></p>
            <p>21/22, Alandur Road, WeWork Olympia Cyberspace</p>
            <p>Arulayiammanpet, 2nd Street, Guindy, Chennai 600032</p>
            <p>Email: prangiodesigns@gmail.com</p>
            <p>Phone: +91 (776) 003-4934</p>
          </div>
        </section>
      </div>
    </div>
  );
};

export default TermsOfService;
